const { innerWidth, innerHeight } = window;

export const mobileScreenSize = 550
export const isMobileScreen = innerWidth < mobileScreenSize 
export const isPortraitMode = innerWidth > innerHeight 
